// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.input-password[data-v-d044ecf0]{\n  width: 300px;\n}\n.modify-password[data-v-d044ecf0]{\n  /* margin: 0 10px 0 50px; */\n}\n.dialog-footer[data-v-d044ecf0]{\n  text-align: right;\n}\n", ""]);
// Exports
module.exports = exports;
